import useSWR from "swr";
import type { Group, GroupResponse } from "../../shared/types";

const fetcher = (url: string): Promise<Group[]> =>
  fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json() as Promise<GroupResponse>;
    })
    .then((json) => json.data);

/**
 * SWR hook to fetch groups from /api/groups.
 * Revalidates every 5 minutes, on focus, and on reconnect.
 *
 * Requirements: 4.8, 9.5, 9.6
 */
export function useGroups(): {
  data: Group[] | undefined;
  isLoading: boolean;
  error: Error | undefined;
  mutate: () => void;
} {
  const { data, error, isLoading, mutate } = useSWR<Group[], Error>(
    "/api/groups",
    fetcher,
    {
      refreshInterval: 5 * 60 * 1000, // 5 minutes
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      focusThrottleInterval: 60 * 1000, // 60 seconds
      dedupingInterval: 2000,
    }
  );

  return { data, isLoading, error, mutate };
}
